<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.81348 7.15723">
		<path d="M6.40674 0a.75027.75027 0 0 0-.53027.21973L.21973 5.87694A.74992563.74992563 0 0 0 1.28028 6.9375l5.12646-5.12695 5.12647 5.127a.74993977.74993977 0 1 0 1.06054-1.06061L6.93702.21973A.75031.75031 0 0 0 6.40674 0Z"/>
	</svg>
</template>
